<template>
	<div class="apply">
		<div class="box-card">
			<div class="head">
				<span class="applyTitle">会刊信息</span>
				<span class="applyEnd">申请截止时间：2023年9月20日</span>
			</div>

			<div class="introduce">
				<div class="txt">
					<span class="shuoMing">说明</span>1、参展展品介绍将免费为参展企业刊登在展会会刊上，请尽量言简意赅；
				</div>
				<div class="txt">2、此表为参展设备技术介绍，不涉及企业品牌宣传；</div>
				<div class="txt">3、参展商如若在会刊上刊登更多信息，可付费选择会刊广告或企业logo；</div>
				<div class="txt">4、会刊展品介绍内容展商提供，展商须保证所提供内容准确性和完整性；</div>
				<div class="txt">5、逾期未提交本表单，组委会不承诺能够在本届展会会刊刊登贵司展品信息。</div>
			</div>
			<!--  表单开始 -->
			<div class="instance">
				<div class="content">
					<el-form :model="catalogueMsg" ref="catalogueMsg" label-width="124px">
						<el-form-item label="公司名称.中文：" prop="Cname" :rules="[{ required: true }]">
							<span>{{ catalogueMsg.Cname }}</span>
						</el-form-item>

						<el-form-item
							label="公司名称.英文："
							prop="EName"
							:rules="[{ required: true, message: '公司名称不能为空' }]"
						>
							<el-input
								type="age"
								v-model="catalogueMsg.EName"
								autocomplete="off"
								placeholder="请输入公司英文地址"
							></el-input>
						</el-form-item>

						<el-form-item label="展位号：" prop="number">
							<span>{{ catalogueMsg.number }}</span>
						</el-form-item>

						<el-form-item
							label="公司地址.中文："
							prop="CAddress"
							:rules="[{ required: true, message: '公司地址不能为空' }]"
						>
							<el-input
								type="age"
								v-model="catalogueMsg.CAddress"
								autocomplete="off"
								placeholder="请输入公司中文地址"
								maxlength="100"
							></el-input>
						</el-form-item>

						<el-form-item
							label="公司地址.英文："
							prop="EAddress"
							:rules="[{ required: true, message: '公司地址不能为空' }]"
						>
							<el-input
								type="age"
								v-model="catalogueMsg.EAddress"
								autocomplete="off"
								placeholder="请输入公司英文地址"
								maxlength="100"
							></el-input>
						</el-form-item>

						<el-form-item label="邮编：" prop="postCode">
							<el-input
								type="age"
								v-model="catalogueMsg.postCode"
								autocomplete="off"
								placeholder="请输入公司邮编"
								maxlength="100"
							></el-input>
						</el-form-item>

						<el-form-item label="电话：" prop="tel" :rules="[{ required: true, message: '电话不能为空' }]">
							<el-input
								type="age"
								v-model="catalogueMsg.tel"
								autocomplete="off"
								placeholder="请输入公司联系电话"
								maxlength="100"
							></el-input>
						</el-form-item>

						<el-form-item
							label="E-mail："
							prop="email"
							:rules="[{ required: true, message: '邮箱不能为空' }]"
						>
							<el-input
								type="age"
								v-model="catalogueMsg.email"
								autocomplete="off"
								placeholder="请输入公司邮箱"
								maxlength="100"
							></el-input>
						</el-form-item>

						<el-form-item label="网址：" prop="url">
							<el-input
								type="age"
								v-model="catalogueMsg.url"
								autocomplete="off"
								placeholder="请输入公司网址"
								maxlength="100"
							></el-input>
						</el-form-item>

						<!-- 文本域 -->
						<div class="aa">
							<el-form-item label="展品介绍.中文：" prop="Cintroduce" :rules="[{ required: false }]">
								<el-input
									type="textarea"
									:rows="3"
									@input="ctxt"
									v-model="catalogueMsg.Cintroduce"
									maxlength="100"
								></el-input>
								<p class="numberV">
									字数：还可以输入<span class="remaining">{{ ctext }}</span
									>字符,最多还可以输入100字符(含标点以及空格)
								</p>
							</el-form-item>
						</div>
						<!-- 文本域 -->
						<div class="aa">
							<el-form-item label="展品介绍.英文：" prop="Eintroduce" :rules="[{ required: false }]">
								<el-input type="textarea" @input="etxt" v-model="catalogueMsg.Eintroduce" :rows="3" maxlength="100"></el-input>
								<p class="numberV">
									字数：还可以输入<span class="remaining">{{ etext }}</span
									>字符,最多还可以输入100字符(含标点以及空格)
								</p>
							</el-form-item>
						</div>
						<!-- 文本域 -->
					</el-form>
				</div>
			</div>
			<!--  表单结束 -->

			<!-- 展品分类说明 -->
			<div class="instance">
				<p class="title">展品分类目录</p>
				<div class="txt">
					<span class="shuoMing">说明</span>请将贵司参展展品所属分类选中，如未包括请在“其他未注明”予以说明
				</div>
         

		       <!------------展品分类目录--------------->
				<div class="box">
					<div class="item" v-for="(item, index) in equipment" :key="index">
						<div class="left">{{ item.title }}</div>

						<el-collapse class="right" v-model="index" @change="handleChange">
							<el-collapse-item :name="i.title + 1" v-for="(i, k) in item.child" :key="k + 1">
								<template slot="title">
									<span class="twoTitle">{{ i.title }}</span>
									<span class="folding" v-if="i.folding">展开</span>
									<span class="folding" v-else>收起</span>
								</template>

								<div class="cycle">
									<span>
										<el-checkbox-group v-model="checkList" v-if="item.child">
											<el-checkbox
												:label="it.title"
												v-for="(it, kt) in i.child"
												:key="kt"
											></el-checkbox>
										</el-checkbox-group>
									</span>
								</div>
							</el-collapse-item>
						</el-collapse>
					</div>
				</div>
				<!------------------------------------->
				         <div class="bottom">
					<div>
                       <el-form :model="catalogueMsg" ref="category" label-width="100px" class="ruleForm">
						<!-- 文本域 -->
						<div class="category">
							<el-form-item label="其他产品类别"  :rules="[{ required: false }]">
								<el-input
									type="textarea"
									:rows="3"
									v-model="catalogueMsg.category"
								></el-input>
							</el-form-item>
						</div>
					</el-form>
					</div>
					 

                        <div class="btn">  
                              <div class="why" v-show="!flag">审核未通过,请重新填写信息后再提交<el-tooltip class="item" effect="dark" content="信息部分缺失,请查看信息" placement="top-start">
                                  <router-link to="#">未通过原因</router-link>
                                 </el-tooltip></div>
                             <el-button type="primary" v-if="!flag">提交</el-button>
                             <el-button type="primary" v-else>审核中</el-button></div>
					    </div> 
				</div>
				<!-- --------------------------------- -->
			</div>
			<!-- 展品分类说明 -->
		</div>
	</div>
</template>
<script>
import equipment from '../.../../../../../../Json/exhiList.js'
export default {
  data() {
    return {
	equipment,
      //会刊信息表单对象
      catalogueMsg: {
        Cname: "中国煤炭工业国际技术咨询有限责任公司",
        EName: "",
        number: "W0001",
        CAddress: "",
        EAddress: "",
        postCode: "",
        tel: "",
        email: "",
        url: "",
        Cintroduce: "", //展品介绍中文
        Eintroduce: "", //展品介绍英文文
        category: "", //展品分类下的产品类别
      },
      ctext: 100, //中文剩余
      etext: 100, //中文剩余

      //复选框组,存储选中的数组
      checkList: [],

 
     //废弃数据
     /*  equipment: [
        {
          title: "井下开采",
          folding: true,
          child: [
            {
              title: "采煤设备",
              folding: true,
              child: [
                { title: "滚筒洗衣机" },
                { title: "刨煤机" },
                { title: "螺旋钻煤机" },
                { title: "采煤机配件" },
              ],
            },
            {
              title: "工作面支护",
              folding: true,
              child: [
                { title: "工作面液压支架" },
                { title: "端头支架" },
                { title: "过渡支架" },
                { title: "巷道支架" },
                { title: "单体液压支柱" },
                { title: "金属顶梁" },
                { title: "液压支架配件" },
                { title: "工作面刮板输送机" },
              ],
            },
            {
              title: "工作面输送设备",
              folding: true,
              child: [
                { title: "工作面刮板输送机" },
                { title: "转载机" },
                { title: "工作面破碎机" },
                { title: "皮带自移装置" },
                { title: "玛蒂克（转载机头和带式输送机尾自移装置）" },
                { title: "刮板输送机配件-链条" },
                { title: "刮板输送机配件-圆环链" },
                { title: "回柱绞车" },
                { title: "调度绞车" },
              ],
            },
          ],
        },
        {
          title: "井下掘进",
          folding: true,
          child: [
            {
              title: "机械化掘进设备",
              folding: true,
              child: [
                { title: "工作面液压支架" },
                { title: "端头支架" },
                { title: "过渡支架" },
                { title: "巷道支架" },
                { title: "单体液压支柱" },
                { title: "金属顶梁" },
                { title: "液压支架配件" },
                { title: "工作面刮板输送机" },
              ],
            },
            {
              title: "工作面刮板输送机",
              folding: true,
              child: [
                { title: "工作面液压支架" },
                { title: "端头支架" },
                { title: "过渡支架" },
                { title: "巷道支架" },
                { title: "单体液压支柱" },
                { title: "金属顶梁" },
                { title: "液压支架配件" },
                { title: "工作面刮板输送机" },
              ],
            },
            {
              title: "端头支架",
              folding: true,
              child: [
                { title: "工作面液压支架" },
                { title: "端头支架" },
                { title: "过渡支架" },
                { title: "巷道支架" },
                { title: "单体液压支柱" },
                { title: "金属顶梁" },
                { title: "液压支架配件" },
                { title: "工作面刮板输送机" },
              ],
            },
            {
              title: "过渡支架",
              folding: true,
              child: [
                { title: "工作面液压支架" },
                { title: "端头支架" },
                { title: "过渡支架" },
                { title: "巷道支架" },
                { title: "单体液压支柱" },
                { title: "金属顶梁" },
                { title: "液压支架配件" },
                { title: "工作面刮板输送机" },
              ],
            },
          ],
        },
        {
          title: "井下运输",
          folding: true,
          child: [
            {
              title: "机械化掘进设备",
              folding: true,
              child: [
                { title: "工作面液压支架" },
                { title: "端头支架" },
                { title: "过渡支架" },
                { title: "巷道支架" },
                { title: "单体液压支柱" },
                { title: "金属顶梁" },
                { title: "液压支架配件" },
                { title: "工作面刮板输送机" },
              ],
            },
          ],
        },
      ], */

      //标志位
      flag: false,
    };
  },
  methods: {
    //文本域计算剩余字数
    ctxt() {
      this.ctext = 100 - Number(this.catalogueMsg.Cintroduce.length);
    },
    etxt() {
      this.etext = 100 - Number(this.catalogueMsg.Eintroduce.length);
    },
    handleChange(val) {
      const index = val[0];
      let str = null;
      let arr = [...val];
      arr.shift();
      this.equipment[index].child.forEach((item) => {
        item.folding = true;
      });

      this.foldClose(arr, index, str);
    },

    foldClose(arr,index, str) {
      if (arr.length != 0) {
        arr.forEach((item) => {
          str = item.replace(/1/, "");
          this.equipment[index].child.forEach((i) => {
            i.title == str ? (i.folding = false) : "";
          });
        });
      } else {
        this.equipment[index].child.forEach((i) => {
          i.folding = true;
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.apply {
  padding: 17px 26px;
  box-sizing: border-box;
  background: #f0f2f5;
  .box-card {
    width: 100%;
    border-radius: 2px;
    background: #ffffff;
    .head {
      padding: 17px 0px;
      border-bottom: 1px solid #e8e8e8;
      .applyTitle {
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
        margin-left: 26px;
      }
      .applyEnd {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 17px;
        margin-left: 17px;
      }
    }
    //说明
    .introduce {
      margin: 26px 17px 0px 17px;
	  padding-bottom: 10px;
      background: #f6f6f7;
      .txt {
        padding-left: 65px;
        box-sizing: border-box;
        position: relative;
        padding-top: 9px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        .shuoMing {
          position: absolute;
          top: 9px;
          left: 26px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff190c;
        }
      }
    }
    //标题
    .instance {
      margin: 0px 17px 0px 17px;
      .title {
        padding: 35px 0px 9px 0px;
        border-bottom: 1px solid #e9e9e9;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
      }
      .txt {
        margin-top: 17px;
        padding-left: 65px;
        box-sizing: border-box;
        position: relative;
        padding-top: 9px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        height: 36px;
        background: #f6f6f7;
        .shuoMing {
          position: absolute;
          top: 9px;
          left: 26px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff190c;
        }
      }
      .content {
        width: 50%;
        margin: 0 auto;
        margin-top: 35px;
        position: relative;
        left: -40px;
        .telNumber {
          color: #006fb8;
          margin-left: 5px;
        }
        .numberV {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 19px;
          letter-spacing: 1px;
          .remaining {
            color: #ff190c;
          }
        }
      }
      //展品信息分类
      .box {
        width: 60%;
        position: relative;
        left: 161px;
        //每一项开始
        .item {
          width: 100%;
          display: flex;
          justify-content: space-between;
          .left {
            width: 172px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 19px;
            text-align: right;
            padding-right: 17px;
            padding-top: 10px;
            box-sizing: border-box;
          }
          .right {
            flex: 1;
            position: relative;
            .twoTitle {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .folding {
              position: absolute;
              right: 30px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
            }
          }
        }

        //每一项结束
      }
      .bottom {
        width: 60%;
        position: relative;
        left: 161px;
        .btn {
          margin-top: 22px;
          padding-bottom: 30px;
          .why {
            margin-left: 120px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ff190c;
            margin-bottom: 22px;
            a {
              margin-left: 10px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #006fb8;
            }
          }
        }
      }
    }
  }
}
</style>
<style scoped>
.el-form >>> .el-form-item__label {
  line-height: 12px;
  padding: 0px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-top: 7px;
}
.el-form >>> .el-form-item__content {
  line-height: 28px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.el-form >>> .el-form-item {
  margin-bottom: 20px;
}
.el-form >>> .el-input {
  width: 468px;
}
.el-form >>> .el-input__inner {
  width: 468px;
  height: 28px;
}
.msg {
  margin-left: -55px;
}
.el-button--primary {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  width: 76px;
  height: 28px;
  line-height: 0px;
  background-color: #006fb8;
  text-align: center;
  margin-left: 105px;
}
.aa >>> .el-form-item__label::before {
  content: "*";
  color: red;
}
.el-textarea >>> .el-textarea__inne {
  min-height: 450px !important;
}
.aa {
  width: 592px;
}
.bottom >>> .el-textarea__inne {
  min-height: 450px !important;
}
.category {
  width: 730px;

  padding-top: 35px;
}
.category >>> .el-form-item__label {
  position: relative;
  left: -12px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 19px;
}
.category >>> .el-textarea__inner {
  margin-left: 5px;
}
</style>
<style scoped>
.right >>> .el-collapse-item__header {
  border-bottom: 1px solid #006fb8 !important;
  height: 36px;
}
/* .right >>> .el-collapse-item__arrow {
	float: left;
	position: absolute;
	left: 90px;
} */
.right >>> .el-checkbox {
  margin: 10px 0px 0px 45px;
}

.el-checkbox >>> .el-checkbox__label {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
</style>
